module.exports = __webpack_public_path__ + "img/lu.4c22c1f8.svg";